
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 21.004H5.998a3.001 3.001 0 01-3.002-3.001V5.998a3.001 3.001 0 013.002-3.002h12.005a3.001 3.001 0 013 3.002V12M21.004 7.998H2.996","stroke":"#323232","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.75 11.45a.049.049 0 100 .098.049.049 0 000-.098M10.248 11.45a.048.048 0 00-.047.049.05.05 0 10.047-.049M6.747 11.45a.048.048 0 00-.05.05.05.05 0 10.049-.049M10.248 14.451a.048.048 0 00-.047.05.049.049 0 10.047-.05M6.747 14.451a.048.048 0 00-.05.05.049.049 0 10.049-.049M6.747 17.453a.048.048 0 00-.049.05.049.049 0 10.048-.05","stroke":"#323232","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18 21v-6M15 18.001h6","stroke":"#D07D01","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    